import { DOCUMENT, Inject, Injectable } from '@angular/core';
import { WINDOW } from '../state/app-config/factories/window.factory';

@Injectable({
    providedIn: 'root',
})
export class GlobalService {
    constructor(
        /** @deprecated - Use DOCUMENT injection token */
        @Inject(DOCUMENT) public document: Document,
        /** @deprecated - Use WINDOW injection token */
        @Inject(WINDOW) public window: Window
    ) {}

    /** @deprecated - Use WINDOW injection token */
    get location(): Location {
        return this.window.location;
    }
}
